<app-inner-box>
  <app-subpage-header [title]="title"></app-subpage-header>
  <app-list #listComponent (reloadBatchDocumentsList)="batchesListComponent.onRefreshList()" (loaded)="ordersLoaded($event)"></app-list>
</app-inner-box>
<app-inner-box>
  <app-subpage-header title="Generierte Batch-Dokumente" tooltipText="In der Tabelle unten finden Sie die Batch-Dokumente der letzten 7 Tage."></app-subpage-header>
  <br>
  <app-batches-list #batchesListComponent></app-batches-list>
</app-inner-box>
